// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__t0m7l","log":"ModalInventoryLogs_log__l4xNK","date":"ModalInventoryLogs_date__2M9HT","userName":"ModalInventoryLogs_userName__1XeR8"};